import { EntityAttendance } from "../../entity/EntityAttendance";

export class DtoAttendancesPutRes extends EntityAttendance {}
